export enum ChannelType {
    PANEL = 'PANEL',
    APP = 'APP',
    CORE = 'CORE'
}
